/* tslint:disable */
/* eslint-disable */
/**
 * TRWL API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import type { SaleProperty } from './sale-property';

/**
 * 
 * @export
 * @interface Variant
 */
export interface Variant {
    /**
     * 
     * @type {number}
     * @memberof Variant
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof Variant
     */
    'skuId': number;
    /**
     * 
     * @type {number}
     * @memberof Variant
     */
    'productId': number;
    /**
     * 
     * @type {number}
     * @memberof Variant
     */
    'price': number;
    /**
     * 
     * @type {number}
     * @memberof Variant
     */
    'stock': number;
    /**
     * 
     * @type {string}
     * @memberof Variant
     */
    'source': VariantSourceEnum;
    /**
     * 
     * @type {Array<SaleProperty>}
     * @memberof Variant
     */
    'saleProperties': Array<SaleProperty>;
    /**
     * 
     * @type {string}
     * @memberof Variant
     */
    'updatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof Variant
     */
    'createdAt': string;
    /**
     * 
     * @type {number}
     * @memberof Variant
     */
    'minDelivery': number;
    /**
     * 
     * @type {number}
     * @memberof Variant
     */
    'maxDelivery': number;
}

export const VariantSourceEnum = {
    Dewu: 'DEWU',
    Poizon: 'POIZON',
    OpenPoizon: 'OPEN_POIZON'
} as const;

export type VariantSourceEnum = typeof VariantSourceEnum[keyof typeof VariantSourceEnum];


